import React, { useState, useEffect } from "react";

import {getLog, postLog} from '../helpers/log';
import {validateEmail} from "../helpers/validate-email";
import RoundUp from "./RoundUp";

// member ticket section
const MemberTickets = (props) => {
    const {memberInfo, selectedTimeIndex, selectedMemberTickets, todaysTicketData} = props;

    // const MemberAdultPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Adult');
    // const MemberYouthPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Youth');
    // const MemberChildPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Child');
    const MemberGuestAdultPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Guest Adult');
    const MemberGuestYouthPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Guest Youth');
    // const MemberGuestPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Guest');

    return (
        <>
            <h5 className="ticket-summary__heading">{memberInfo.primaryCardHolder.membershipCategory}<hr/></h5>
            <ul className="ticket-summary__list">
                {selectedMemberTickets['Member Adult'] > 0 && <li>{selectedMemberTickets['Member Adult']} adult{selectedMemberTickets['Member Adult'] > 1 && 's'} <small>(Ages 18 &amp; over)</small> <span>FREE</span></li>}
                {selectedMemberTickets['Member Youth'] > 0 && <li>{selectedMemberTickets['Member Youth']} youth{selectedMemberTickets['Member Youth'] > 1 && 's'} <small>(Ages 4 - 18)</small> <span>FREE</span></li>}
                {selectedMemberTickets['Member Child'] > 0 && <li>{selectedMemberTickets['Member Child']} child{selectedMemberTickets['Member child'] > 1 && 'ren'} <small>(Ages 3 &amp; under)</small> <span>FREE</span></li>}
            </ul>
            {selectedMemberTickets['Member Guest'] > 0 && <>
                <h6>Membership plus ticket</h6>
                <ul className="ticket-summary__list">
                    {selectedMemberTickets['Member Guest'] > 0 && <li>{selectedMemberTickets['Member Guest']} guest{selectedMemberTickets['Member Guest'] > 1 && 's'} <span>FREE</span></li>}
                </ul>
            </>}
            {(selectedMemberTickets['Member Guest Adult'] > 0 || selectedMemberTickets['Member Guest Youth'] > 0) && <>
                <h6>Half price member benefit tickets</h6>
                <ul className="ticket-summary__list">
                    {(selectedMemberTickets['Member Guest Adult'] > 0 && todaysTicketData[selectedTimeIndex] != undefined) && <li>{selectedMemberTickets['Member Guest Adult']} half priced adult{selectedMemberTickets['Member Guest Adult'] > 1 && 's'} <span>${((MemberGuestAdultPrice[0]?.price ?? 0) * selectedMemberTickets['Member Guest Adult']).toFixed(2)}</span></li>}
                    {(selectedMemberTickets['Member Guest Youth'] > 0 && todaysTicketData[selectedTimeIndex] != undefined) && <li>{selectedMemberTickets['Member Guest Youth']} half priced youth{selectedMemberTickets['Member Guest Youth'] > 1 && 's'} <span>${((MemberGuestYouthPrice[0]?.price ?? 0) * selectedMemberTickets['Member Guest Youth']).toFixed(2)}</span></li>}
                </ul>
            </>}
        </>
    );
}

// additonal ticket section
const AdditionalTickets = (props) => {
    const {isMember, selectedTickets, todaysTicketData, selectedTime} = props;

    let selectedTimeIndex;
    todaysTicketData.forEach((entry, index) => {
        if (entry.name.indexOf(selectedTime) != -1) {
            selectedTimeIndex = index;
        }
    });

    const AdultPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Adult');
    const YouthPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Youth');
    const ChildPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Child');

    return (
        <>
            <h5 className="ticket-summary__heading">{(isMember) ? 'Additional tickets' : 'Tickets'}<hr/></h5>
            <ul className="ticket-summary__grid">
                {selectedTickets['Adult'] > 0 && <li>
                    <p><b>Adult</b></p>
                    <p><small>(Ages 13 & over)</small></p>
                    <p>{selectedTickets['Adult']}</p>
                    <p>${AdultPrice.length > 0 && parseFloat(AdultPrice[0].price * selectedTickets['Adult']).toFixed(2)}</p>
                </li>}
                {selectedTickets['Youth'] > 0 && <li>
                    <p><b>Youth</b></p>
                    <p><small>(Ages 4 - 12)</small></p>
                    <p>{selectedTickets['Youth']}</p>
                    <p>${YouthPrice.length > 0 && parseFloat(YouthPrice[0].price * selectedTickets['Youth']).toFixed(2)}</p>
                </li>}
                {selectedTickets['Child'] > 0 && <li>
                    <p><b>Child</b></p>
                    <p><small>(Ages 3 & under)</small></p>
                    <p>{selectedTickets['Child']}</p>
                    <p>{ChildPrice.length > 0 && (ChildPrice[0].price == 0 ? 'Free' : '$' + parseFloat(ChildPrice[0].price).toFixed(2))}</p>
                </li>}
            </ul>
        </>
    )
}

// TicketSelectionSummary component; used to list all selected tickets
const TicketSelectionSummary = (props) => {
    const {
        config,
        addonData,
        applicableServiceFees,
        serviceFeeTotal,
        authenticationToken,
        activeSummaryScreen,
        fetchData,
        isWAResident,
        isMember,
        memberInfo,
        selectedAddons,
        selectedDay,
        selectedTime,
        selectedTimeIndex,
        selectedTickets,
        selectedMemberTickets,
        todaysTicketData,
        setTodaysTicketData,
        donationAmount,
        shouldRoundUp,
        setShouldRoundUp,
        roundUpAmount,
        setRoundUpAmount,
        hasPromoCode,
        setHasPromoCode,
        promoCode,
        setPromoCode,
        promoCodeStatus,
        setPromoCodeStatus,
        setWillSubscribe,
        willSubscribe,
        setSubscriptionEmail,
        subscriptionEmail,
        setSubscriptionEmailStatus,
        subscriptionEmailStatus,
        getCartData,
        cartTotal,
        updateCartTotal,
    } = props;

    const [chosenDay, setChosenDay] = useState(null);
    const [isChecking, setIsChecking] = useState(false);
    const [promoName, setPromoName] = useState(null);
    const [finalTotal, setFinalTotal] = useState('0.00');

    const dateOptions = {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
    };

    // Promo code checker
    const checkPromoCode = async (promoCode) => {
        setIsChecking(true);
        try {
            const response = await fetch(`https://${config.apiUrl}/api/coupons/check`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Authorization": authenticationToken
                },
                body: JSON.stringify({
                    "couponCode": promoCode,
                    "cart": getCartData()
                })
            });
            if (!response.ok) {
                setIsChecking(false);
                postLog(config, authenticationToken, response.url, String(response.status));
                throw new Error(response);
            }
            const data = await response.json();
            console.log(data.data);
            
            if (data.data.coupon?.id == null) {
                if(promoCodeStatus === 'valid') {
                    fetchData();
                }

                setPromoCodeStatus('invalid');
                setPromoName(null);
            } else {
                setPromoCodeStatus('valid');
                setPromoName(data.data.coupon.name);

                if(data.data.cart?.items.length && todaysTicketData) {
                    for(const item of data.data.cart.items) {
                        const event = todaysTicketData.find(e => e.general_event_id === item.eventId);

                        if(event) {
                            const price = event.prices.find(p => p.applies_to_id === item.ticketingTypeId);

                            if(price) {
                                price.price = parseFloat(item.unitPrice);
                            }
                        }
                    }

                    setTodaysTicketData(todaysTicketData);
                    setTimeout(updateCartTotal, 0);
                }
            }

            setIsChecking(false);
        } catch (error) {
            console.error(error);
            setIsChecking(false);
        }
    };

    useEffect(() => {
        // format selectedDay
        if (selectedDay !== null) {
            setChosenDay(new Date(selectedDay.replace(/-/g, '/')));
        }

    }, [selectedDay])

    useEffect(() => {
        // calculate the amount needed to round up
        let centsRemainder = (parseFloat(cartTotal) + parseFloat(donationAmount)).toFixed(2).split('.')[1];
        if (centsRemainder !== '00') {
            setRoundUpAmount(((100 - parseInt(centsRemainder)) / 100).toFixed(2));
        } else {
            setRoundUpAmount('0.00');
        }

        // calculate final total
        if (shouldRoundUp) {
            setFinalTotal(((parseFloat(cartTotal)) + parseFloat(donationAmount) + parseFloat(roundUpAmount)).toFixed(2));
        } else {
            setFinalTotal((parseFloat(cartTotal) + parseFloat(donationAmount)).toFixed(2));
        }
    }, [activeSummaryScreen, cartTotal, donationAmount, shouldRoundUp]);

    let addonsTotal = 0;

    if(addonData && selectedAddons) {
        for(const [addonId, addonQuantity] of Object.entries(selectedAddons)) {
            if(addonQuantity) {
                addonsTotal += addonData[addonId].price * addonQuantity;
            }
        }
    }

    return (
        <>
            <h5 className="ticket-summary__title">Your Visit <span>{chosenDay ? chosenDay.toLocaleString('en-US', dateOptions) : ''} @ {selectedTime}</span></h5>
            {isMember && todaysTicketData && selectedTimeIndex != null && <MemberTickets
                memberInfo={memberInfo}
                selectedTimeIndex={selectedTimeIndex}
                selectedMemberTickets={selectedMemberTickets}
                todaysTicketData={todaysTicketData}
            />}
            {Object.values(selectedTickets).reduce((total, current) => total + current, 0) > 0 && selectedTimeIndex != null && <AdditionalTickets
                isMember={isMember}
                selectedTickets={selectedTickets}
                todaysTicketData={todaysTicketData}
                selectedTime={selectedTime}
            />}
            {(activeSummaryScreen === 'review' && !!addonsTotal) && <div className="ticket-summary__donation">
                <h5 className="ticket-summary__heading">Add-ons<hr/></h5>
                <ul className="ticket-summary__list">
                    {Object.entries(selectedAddons).map(([addonId, addonQuantity]) => (
                        <li>{addonData[addonId].name} - {addonQuantity} x ${addonData[addonId].price.toFixed(2)} <span>${(addonData[addonId].price * addonQuantity).toFixed(2)}</span></li>
                    ))}
                </ul>
            </div>}
            {serviceFeeTotal > 0 && <div className="ticket-summary__donation">
                <h5 className="ticket-summary__heading">Service Fee<hr/></h5>
                <ul className="ticket-summary__list">
                    {applicableServiceFees.map((fee, i) => (
                        <li key={i} className="ticket-summary__list__serviceFee">
                            <span className="ticket-summary__list__serviceFee__description">
                                {/*fee.inventoryName*/}
                                This fee helps our nonprofit aquarium cover payment processing costs, so more of your support goes toward our mission—thank you!
                            </span>
                            <span className="ticket-summary__list__serviceFee__amount">${(fee.unitPrice * fee.quantity).toFixed(2)}</span>
                        </li>
                    ))}
                </ul>
            </div>}
            {(activeSummaryScreen === 'review' && parseFloat(donationAmount) > 0) && <div className="ticket-summary__donation">
                <h5 className="ticket-summary__heading">Donation<hr/></h5>
                <ul className="ticket-summary__list">
                    <li>Chosen amount <span>${donationAmount}</span></li>
                </ul>
            </div>}
            {activeSummaryScreen === 'review' && cartTotal !== '0.00' && <div className="ticket-summary__promo">
                <h5 className="ticket-summary__heading">Promo code<hr/></h5>
                <div className="fieldgroup fieldgroup--checkbox">
                    <input type="checkbox" id="have-promo" checked={hasPromoCode} onClick={() => {
                        if(hasPromoCode) {
                            fetchData();
                        }

                        setHasPromoCode(!hasPromoCode)
                    }}/>
                    <label  htmlFor="have-promo">I have a promo code</label>
                </div>
                <div className="fieldgroup" style={{display: hasPromoCode ? 'block' : 'none'}}>
                    <label htmlFor="promo-code">Promo code</label>
                    <input
                        className={`ticket-summary__promo-input ${(promoCodeStatus == 'invalid') ? 'ticket-summary__promo-input--error' : ''} ${(promoCodeStatus == 'valid') ? 'ticket-summary__promo-input--success' : ''}`}
                        type="text"
                        id="promo-code"
                        value={promoCode}
                        onChange={(e) => {
                            setPromoCode(e.target.value);
                            setPromoCodeStatus(null);
                            setPromoName(null);
                        }}/>
                    <p style={{ fontStyle: "italic;" }}>Promo codes are case sensitive.</p>
                    {promoCodeStatus == 'invalid' && <p className="ticket-summary__promo-message ticket-summary__promo-message--error">Invalid promo code.</p>}
                    {promoCodeStatus == 'valid' && <p className="ticket-summary__promo-message ticket-summary__promo-message--success">{promoName} applied.</p>}
                    {promoCodeStatus != 'valid' && <button
                        className="button"
                        onClick={() => checkPromoCode(promoCode)}
                        disabled={promoCode == null || promoCode.length < 1 || isChecking}
                    >
                        {!isChecking ? 'Apply' : <i className="fa fa-spinner fa-pulse"></i>}
                    </button>}
                </div>
            </div>}
            {(activeSummaryScreen === 'review') && <RoundUp
                donationAmount={donationAmount}
                roundUpAmount={roundUpAmount}
                shouldRoundUp={shouldRoundUp}
                setShouldRoundUp={setShouldRoundUp}
            />}
            {(activeSummaryScreen === 'review') && <div className="ticket-summary__newsletter">
                <h5 className="ticket-summary__heading">Subscribe to Newsletter<hr/></h5>
                <div className="fieldgroup fieldgroup--checkbox">
                    <input
                        type="checkbox"
                        id="will-subscribe"
                        checked={willSubscribe}
                        onClick={() => setWillSubscribe(!willSubscribe)}
                    />
                    <label htmlFor="will-subscribe">I would like to subscribe to the Seattle Aquarium newsletter</label>
                </div>
                <div className="fieldgroup" style={{display: willSubscribe ? 'block' : 'none'}}>
                    <label htmlFor="subscription-email">Email address</label>
                    <input
                        className={`ticket-summary__promo-input ${(subscriptionEmailStatus == 'invalid') ? 'ticket-summary__subscription-email-input--error' : ''} ${(subscriptionEmailStatus == 'valid') ? 'ticket-summary__subscription-email-input--success' : ''}`}
                        type="email"
                        id="subscription-email"
                        required={willSubscribe}
                        value={subscriptionEmail}
                        onChange={(e) => {
                            const newEmail = e.target.value;

                            setSubscriptionEmail(newEmail);
                            setSubscriptionEmailStatus((newEmail && validateEmail(newEmail)) ? 'valid' : 'invalid');
                        }}/>
                    {subscriptionEmailStatus == 'invalid' && <p className="ticket-summary__subscription-email-message ticket-summary__subscription-email-message--error">Invalid email address.</p>}
                </div>
            </div>}
            <div className="ticket-summary__total">
                <span className="ticket-summary__total-title">Your total</span>
                <span className="ticket-summary__total-amount">
                    ${activeSummaryScreen === 'review' ? finalTotal : cartTotal}
                </span>
            </div>
        </>
    );
}

export default TicketSelectionSummary;